import GLightbox from 'glightbox'

/**
 * GLightbox für Elemente mit Klasse .glightbox.
 */
export function lightbox() {
	if (!document.querySelector('.glightbox')) return

	GLightbox({
		loop: true,
		touchNavigation: true,
		autoplayVideos: false,
		openEffect: 'fade',
		closeEffect: 'fade',
		slideEffect: 'fade',
		videosWidth: '1440px'
	})
}
